// extracted by mini-css-extract-plugin
module.exports = {"logoPrimaryFill":"SidebarTopBar_logoPrimaryFill__plgm7"};